import * as React from 'react'
import { FC, useEffect, useMemo, useState } from 'react'
import { ClientData, FeatureEnum, Invoice, InvoiceData, InvoiceDocumentType, InvoiceItem, InvoiceItemType, InvoiceState, PaymentStatus, PermissionEnum, RelatedDoc } from '../../models'
import { getEntitiesDataItems } from '../../store/entities/selectors'
import { useDispatch, useSelector } from 'react-redux'
import { ClientEntity } from '../../store/entities/state'
import { AutocompleteTextField, CheckInputField, NumberInputField, SelectTextField, TextInputField } from './fields'
import { Checkbox, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { useTranslations } from '../../store/translations/hooks'
import { TK } from '../../store/translations/translationKeys'
import moment from 'moment'
import DeleteIcon from '@material-ui/icons/CancelRounded';
import AddCircleIcon from '@material-ui/icons/AddCircleRounded';
import DownloadIcon from '@material-ui/icons/GetAppRounded'
import CheckIcon from '@material-ui/icons/CheckCircleRounded'
import EventIcon from '@material-ui/icons/EventRounded'
import LocalOfferIcon from '@material-ui/icons/LocalOfferRounded'
import PersonIcon from '@material-ui/icons/PersonRounded'
import InfoIcon from '@material-ui/icons/InfoOutlined'
import MailIcon from '@material-ui/icons/EmailRounded'
import LinkIcon from '@material-ui/icons/LinkRounded'
import { Alert, Modal, ModalBody, ModalHeader } from 'reactstrap'
import AppButton from '../AppButton'
import ToolTip from '../ToolTip'
import Typography from '../Typography'
import { formatEuros } from '../../shared/string'
import { TaxDataHook } from '../../hooks/useTaxData'
import { getInvoiceCatalog, getInvoiceSettings, getSettings } from '../../store/settings/selectors'
import { loadInvoiceCatalog } from '../../store/settings/actions'
import { getClientAsync, getInvoicesAsync, getInvoiceAsync } from '../../ajax/requests'
import { getErrorMessage } from '../../ajax/errors'
import { alertError } from '../../store/alerts/actions'
import { getInvoiceTypeText, resolveEffectiveLegalInfo } from '../../shared/appointmint/invoice'
import { serviceName } from '../../shared/appointmint/appointment'
import { useGeneralSettings } from '../../store/settings/hooks'
import {
    canSelectInvoiceAppointmentBranch,
    getInvoiceBranchFilterOptions,
    getSelectedInvoiceBranchKey,
    resolveInvoiceBranchFilterId,
} from '../../shared/appointmint/invoiceBranches'
import {
    createClientSearchConfig,
} from '../../shared/clientSearch'
import { useInvoiceAppointments } from '../../hooks/useInvoiceAppointments'
import { InvoiceAssignModal } from './InvoiceAssignModal'
import { getPermissions, hasFeature } from '../../store/session/selectors'
import { getSelectedBranch } from '../../store/general/selectors'
import { PaymentLabel } from './fields/PaymentsList'

const PercentIcon = () => (<svg fill="var(--text-muted)" width="20px" height="20px" viewBox="0 0 440.994 440.994">
<g>
	<g>
		<path d="M274.61,249.183c-5.044,0-8.816,3.714-10.618,5.929c-4.025,4.951-6.336,12.059-6.336,19.499s2.311,14.548,6.336,19.5
			c1.802,2.214,5.574,5.928,10.618,5.928s8.816-3.714,10.618-5.928c4.025-4.952,6.336-12.06,6.336-19.5s-2.311-14.548-6.336-19.499
			C283.428,252.896,279.654,249.183,274.61,249.183z"/>
		<path d="M166.384,191.81c5.044,0,8.816-3.714,10.618-5.928c4.026-4.952,6.336-12.059,6.336-19.5c0-7.441-2.31-14.547-6.336-19.499
			c-1.802-2.214-5.574-5.928-10.618-5.928c-5.044,0-8.816,3.714-10.618,5.928c-4.026,4.952-6.336,12.058-6.336,19.499
			c0,7.441,2.31,14.548,6.336,19.5C157.567,188.097,161.34,191.81,166.384,191.81z"/>
		<path d="M435.289,209.037l-53.984-40.794l19.699-64.751c1.312-4.31,0.525-8.984-2.123-12.628
			c-2.647-3.643-6.854-5.833-11.356-5.916l-67.672-1.235l-22.065-63.997c-1.469-4.262-4.855-7.587-9.143-8.979
			c-4.283-1.393-8.979-0.692-12.675,1.892l-55.475,38.814L165.02,12.627c-3.693-2.583-8.387-3.285-12.674-1.892
			c-4.289,1.393-7.672,4.718-9.143,8.979l-22.064,63.996l-67.672,1.236c-4.502,0.083-8.707,2.272-11.355,5.916
			c-2.648,3.644-3.436,8.319-2.125,12.628l19.701,64.75L5.705,209.037C2.111,211.751,0,215.995,0,220.497
			c0,4.503,2.111,8.746,5.705,11.461l53.984,40.794L39.99,337.502c-1.311,4.31-0.523,8.984,2.125,12.628
			c2.648,3.643,6.854,5.833,11.355,5.916l67.672,1.236l22.064,63.996c1.469,4.262,4.854,7.587,9.141,8.979
			c4.285,1.394,8.98,0.692,12.674-1.893l55.475-38.814l55.477,38.815c2.443,1.709,5.324,2.595,8.236,2.595
			c1.488,0,2.986-0.23,4.438-0.703c4.286-1.393,7.672-4.718,9.141-8.979l22.063-63.996l67.675-1.237
			c4.502-0.083,8.707-2.272,11.354-5.916c2.648-3.644,3.437-8.318,2.125-12.628l-19.701-64.749l53.984-40.795
			c3.594-2.715,5.705-6.958,5.705-11.461S438.883,211.75,435.289,209.037z M166.384,121.01c20.38,0,36.901,20.314,36.901,45.374
			c0,25.061-16.521,45.375-36.901,45.375c-20.38,0-36.901-20.314-36.901-45.375C129.482,141.324,146.004,121.01,166.384,121.01z
			 M164.038,320.178c-2.307,3.209-6.047,5.125-10.005,5.125c-2.581,0-5.059-0.8-7.163-2.312c-5.509-3.957-6.771-11.658-2.813-17.167
			l132.9-185.01c2.306-3.209,6.046-5.125,10.005-5.125c2.58,0,5.058,0.8,7.162,2.312c5.509,3.957,6.771,11.658,2.813,17.167
			L164.038,320.178z M274.61,319.983c-20.38,0-36.901-20.313-36.901-45.375c0-25.059,16.521-45.373,36.901-45.373
			s36.9,20.314,36.9,45.373C311.512,299.669,294.99,319.983,274.61,319.983z"/>
	</g>
</g>
</svg>)

export interface InvoiceFormProps {
    value: InvoiceData | Invoice
    clientEmail?: string
    fetching?: boolean
    taxHook: TaxDataHook
    showNavigationButtons?: boolean
    allowCreditNote?: boolean
    isFinalConsumer?: boolean
    onClose?: () => void
    onChange?: (value: InvoiceData) => void
    onFinalConsumerChange?: (isFinalConsumer: boolean) => void
    onSendByEmail?: () => void
    onGeneratePdf?: () => void
    onSubmit?: () => void
    onFinalize?: () => void
    onCancel?: () => void
    onDelete?: () => void
    onEmitReceipt?: () => void
    onNavigateToRelatedDoc?: (relatedDocId: string) => void
    onOpenAppointment?: () => void
    onOpenPack?: () => void
    onAssociatedDocumentChange?: (documentId: string) => void
    appointmentIds?: string[]
    onAppointmentIdsChange?: (appointmentIds: string[]) => void
    paymentMethod?: string
    onPaymentMethodChange?: (paymentMethod: string) => void
    paymentMethodOptions?: string[]
}

export const InvoiceForm: FC<InvoiceFormProps> = ({
    value,
    clientEmail,
    fetching,
    taxHook,
    showNavigationButtons,
    allowCreditNote,
    isFinalConsumer: isFinalConsumerProp,
    onClose,
    onChange,
    onFinalConsumerChange,
    onSubmit,
    onSendByEmail,
    onGeneratePdf,
    onFinalize,
    onCancel,
    onDelete,
    onEmitReceipt,
    onNavigateToRelatedDoc,
    onOpenAppointment,
    onOpenPack,
    onAssociatedDocumentChange,
    appointmentIds,
    onAppointmentIdsChange,
    paymentMethod,
    onPaymentMethodChange,
    paymentMethodOptions,
}) => {

    const t = useTranslations()
    const generalSettings = useGeneralSettings()
    const isExistingInvoice = 'id' in value
    const invoiceState = isExistingInvoice ? (value as Invoice).state : InvoiceState.None
    const sentByEmail = isExistingInvoice ? ((value as Invoice).sentByEmail ?? false) : false
    const sentByEmailAt = isExistingInvoice ? (value as Invoice).sentByEmailAt : undefined

    const dispatch = useDispatch()
    const settings = useSelector(getSettings)
    const invoiceSettings = useSelector(getInvoiceSettings)
    const userPermissions = useSelector(getPermissions)
    const useBranches = useSelector(hasFeature(FeatureEnum.Branches))
    const selectedBranch = useSelector(getSelectedBranch)
    const allClients = useSelector(getEntitiesDataItems<ClientEntity>('clients'))
    const FINAL_CONSUMER_OPTION = t(TK.finalConsumer)
    const clientSearchConfig = useMemo(
        () => createClientSearchConfig(allClients, [FINAL_CONSUMER_OPTION]),
        [FINAL_CONSUMER_OPTION, allClients],
    )
    const invoiceItems = useSelector(getInvoiceCatalog)
    const [itemTaxModal, setItemTaxModal] = useState<number|undefined>()
    const [associatedDocumentId, setAssociatedDocumentId] = useState<string>('')
    const [assignModalOpen, setAssignModalOpen] = useState(false)
    const [availableInvoices, setAvailableInvoices] = useState<Invoice[]>([])
    const [loadingInvoices, setLoadingInvoices] = useState(false)
    const [isFinalConsumerState, setIsFinalConsumerState] = useState(false)
    const [invoiceClient, setInvoiceClient] = useState<ClientData | undefined>()
    const [discountModalOpen, setDiscountModalOpen] = useState(false)
    const isFinalConsumer = isFinalConsumerProp !== undefined ? isFinalConsumerProp : isFinalConsumerState
    const items = value.items ?? []
    const selectedItem = itemTaxModal !== undefined ? items[itemTaxModal] : undefined

    const ensureItemCode = React.useCallback((item: InvoiceItem): InvoiceItem => {
        const trimmedCode = (item.code ?? '').trim()

        return {
            ...item,
            code: trimmedCode,
            description: item.description ?? '',
        }
    }, [])

    const readOnly = 'id' in value && !!value.id
    const sendEmailDisabled = !clientEmail?.trim()
    const sendEmailTooltip = sendEmailDisabled
        ? t(TK.clientEmailRequiredToSendInvoice)
        : sentByEmail && sentByEmailAt
            ? `${t(TK.emailSentToClientOn)} ${moment(sentByEmailAt).format('DD/MM/YYYY HH:mm')}`
            : t(TK.sendInvoiceToClientEmail)
    const canSelectAppointments = !readOnly
        && !isFinalConsumer
        && !value.appointmentId
        && !value.packId
        && !!value.clientId

    // Use invoice appointments hook for appointment selection logic
    const {
        appointmentsModalOpen,
        setAppointmentsModalOpen,
        appointmentsLoading,
        clientAppointments,
        selectedAppointmentIds,
        setObservationsBase,
        setAppendedNotes,
        handleOpenAppointmentsModal,
        handleAppointmentToggle,
        updateInvoiceItemsFromAppointments,
    } = useInvoiceAppointments({
        value,
        onChange,
        appointmentIds,
        onAppointmentIdsChange,
        canSelectAppointments,
        taxHook,
        client: invoiceClient,
    })

    const orderedAppointments = useMemo(
        () => [...clientAppointments].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()),
        [clientAppointments]
    )
    const selectedAppointmentsBranchKey = useMemo(
        () => getSelectedInvoiceBranchKey(selectedAppointmentIds, clientAppointments),
        [clientAppointments, selectedAppointmentIds]
    )
    const latestValueRef = React.useRef(value)
    const clientSelectionRequestRef = React.useRef(0)

    const getBranchLabel = React.useCallback((branchId?: string) => {
        if (!branchId) {
            return ''
        }

        return settings.general?.branches?.[branchId]?.displayName ?? branchId
    }, [settings.general?.branches])

    const effectiveBranchId = value.branchId ?? (useBranches ? selectedBranch : undefined)
    const branchLabel = getBranchLabel(effectiveBranchId)
    const branchOptions = useMemo(
        () => getInvoiceBranchFilterOptions(settings.general?.branches),
        [settings.general?.branches]
    )
    const branchOptionLabels = useMemo(
        () => branchOptions.map(option => option.label),
        [branchOptions]
    )
    const canEditBranch = useBranches
        && !readOnly
        && !value.appointmentId
        && selectedAppointmentIds.length === 0
    const branchSelectLabel = effectiveBranchId
        ? branchOptions.find(option => option.id === effectiveBranchId)?.label ?? effectiveBranchId
        : ''
    const normalizedBranchSelectLabel = branchSelectLabel || branchOptionLabels[0] || ''

    useEffect(() => {
        latestValueRef.current = value
    }, [value])

    useEffect(() => {
        if (!onChange || !useBranches || readOnly || value.appointmentId || selectedAppointmentIds.length > 0) {
            return
        }

        if (!value.branchId && selectedBranch) {
            onChange({ ...value, branchId: selectedBranch })
        }
    }, [onChange, readOnly, selectedAppointmentIds.length, selectedBranch, useBranches, value])

    // Track original client data to detect changes
    const [originalClientName] = useState(value.clientName)
    const [originalClientTaxNumber] = useState(value.clientTaxNumber)
    const hasClientDataChanged = (value.clientName !== originalClientName) || (value.clientTaxNumber !== originalClientTaxNumber)

    const typeLabel = (value.type === InvoiceDocumentType.Invoice ? t(TK.invoice)
            : value.type === InvoiceDocumentType.InvoiceReceipt ? t(TK.invoiceReceipt)
            : value.type === InvoiceDocumentType.SimplifiedInvoice ? t(TK.simplifiedInvoice)
            : value.type === InvoiceDocumentType.CreditNote ? t(TK.creditNote)
            : value.type === InvoiceDocumentType.Receipt ? t(TK.receipt)
            : InvoiceDocumentType[value.type]);

    useEffect(() => {
        if (!invoiceItems?.defaultItems?.length) {
            dispatch(loadInvoiceCatalog())
        }
    }, [dispatch, invoiceItems?.defaultItems?.length])

    const clearSelectedAppointments = React.useCallback(() => {
        if (selectedAppointmentIds.length > 0) {
            onAppointmentIdsChange && onAppointmentIdsChange([])
            updateInvoiceItemsFromAppointments([])
        }
    }, [onAppointmentIdsChange, selectedAppointmentIds.length, updateInvoiceItemsFromAppointments])

    const handleClientTextChanged = (name?: string) => {
        clientSelectionRequestRef.current += 1

        if (!name) {
            onChange && onChange({
                ...value,
                clientId: '',
                clientName: '',
            })
            setIsFinalConsumerState(false)
            onFinalConsumerChange && onFinalConsumerChange(false)
            clearSelectedAppointments()
            setObservationsBase('')
            setAppendedNotes('')
            return
        }

        setIsFinalConsumerState(false)
        onFinalConsumerChange && onFinalConsumerChange(false)
        onChange && onChange({
            ...value,
            clientId: undefined,
            clientName: name,
        })
        clearSelectedAppointments()
        setObservationsBase(value.observations ?? '')
        setAppendedNotes('')
    }

    const handleClientSelected = (option?: string) => {
        clientSelectionRequestRef.current += 1
        const requestId = clientSelectionRequestRef.current

        if (!option) {
            onChange && onChange({
                ...value,
                clientId: '',
                clientName: '',
            })
            setIsFinalConsumerState(false)
            onFinalConsumerChange && onFinalConsumerChange(false)
            clearSelectedAppointments()
            setObservationsBase('')
            setAppendedNotes('')
            return
        }

        // Check if Final Consumer was selected
        if (option === FINAL_CONSUMER_OPTION) {
            onChange && onChange({
                ...value,
                clientId: undefined,
                clientName: undefined,
                address: undefined,
                city: undefined,
                country: undefined,
                clientTaxNumber: undefined,
            })
            setIsFinalConsumerState(true)
            onFinalConsumerChange && onFinalConsumerChange(true)
            clearSelectedAppointments()
            setObservationsBase('')
            setAppendedNotes('')
            return
        }

        // Reset Final Consumer flag when selecting a real client
        setIsFinalConsumerState(false)
        onFinalConsumerChange && onFinalConsumerChange(false)

        const clientFromList = clientSearchConfig.getClientByOption(option)

        if (!clientFromList) {
            onChange && onChange({
                ...value,
                clientId: undefined,
                clientName: option,
            })
            clearSelectedAppointments()
            setObservationsBase(value.observations ?? '')
            setAppendedNotes('')
            return
        }

        clearSelectedAppointments()

        getClientAsync(clientFromList.id)
            .then((fullClient) => {
                if (clientSelectionRequestRef.current !== requestId) {
                    return
                }

                const subsystemObs = [
                    fullClient.subsystemName,
                    fullClient.subsystemNumber,
                ].filter(v => !!v?.length).join(':')

                setInvoiceClient(fullClient)
                const mergedObservations = [
                    subsystemObs,
                    settings.invoices?.generalObservations,
                ].filter(v => !!v?.length).join('\n')
                const currentValue = latestValueRef.current

                onChange && onChange({
                    ...currentValue,
                    clientId: fullClient.id,
                    clientName: fullClient.name,
                    address: fullClient.addressLine1 ?? currentValue.address,
                    city: fullClient.city ?? currentValue.city,
                    country: 'Portugal',
                    clientTaxNumber: fullClient.taxNumber ?? currentValue.clientTaxNumber,
                    observations: mergedObservations,
                })
                setObservationsBase(mergedObservations)
                setAppendedNotes('')
            })
            .catch((error) => {
                if (clientSelectionRequestRef.current !== requestId) {
                    return
                }

                console.error('Error fetching client:', error)
                const currentValue = latestValueRef.current
                onChange && onChange({
                    ...currentValue,
                    clientId: clientFromList.id,
                    clientName: clientFromList.name,
                    address: clientFromList.addressLine1 ?? currentValue.address,
                    city: clientFromList.city ?? currentValue.city,
                    country: 'Portugal',
                    clientTaxNumber: clientFromList.taxNumber ?? currentValue.clientTaxNumber,
                })
                setObservationsBase(currentValue.observations ?? '')
                setAppendedNotes('')
            })
    }

    const handleItemChanged = (idx: number, newItem: InvoiceItem) => {
        onChange && onChange({
            ...value,
            items: (value.items ?? []).map((item, i) => i !== idx ? item : ensureItemCode(newItem)),
        })
    }

    const handleAddItem = () => {
        const effectiveLegalInfo = resolveEffectiveLegalInfo(invoiceSettings, effectiveBranchId)
        const defaultTaxId = effectiveLegalInfo?.taxId ?? taxHook.taxRates[0]?.id
        onChange && onChange({
            ...value,
            items: [...(value.items ?? []), {
                code: '',
                description: '',
                taxId: defaultTaxId,
                quantity: 1,
                unitPrice: 0,
            }]
        })
    }

    const handleDeleteItem = (idx: number) => () => {
        onChange && onChange({
            ...value,
            items: (value.items ?? []).filter((_, i) => i !== idx),
        })
    }

    const handleDefaultItemSelected = (idx: number) => (code: string) => {
        const currentItem = (value.items ?? [])[idx]
        if (!currentItem) return

        const defaultItem = invoiceItems?.defaultItems.find(i => i.code === code)

        // Only update if a default catalog item was selected
        // Otherwise, let onTextChanged handle manual edits
        if (defaultItem) {
            handleItemChanged(idx, {
                ...currentItem,
                ...defaultItem,
            })
        }
    }

    const handleRelatedDocClick = (relatedDoc: RelatedDoc) => () => {
        if (onNavigateToRelatedDoc) {
            onNavigateToRelatedDoc(relatedDoc.id.toString())
        }
    }

    const handleTaxNumberChange = (clientTaxNumber: string) => {
        // Check for forbidden NIFs
        if (clientTaxNumber === '999999990' || clientTaxNumber === '999999999') {
            dispatch(alertError(t(TK.useFinalConsumerInstead)))
            onChange && onChange({...value, clientId: undefined, clientTaxNumber: ''})
            return
        }
        onChange && onChange({...value, clientId: undefined, clientTaxNumber})
    }

    const handleAssociatedDocumentSelected = (invoiceLabel: string) => {
        if (!invoiceLabel) {
            setAssociatedDocumentId('')
            onAssociatedDocumentChange && onAssociatedDocumentChange('')
            return
        }

        const selectedInvoice = availableInvoices.find(inv => {
            const label = `${getInvoiceTypeText(inv.type, t)} ${inv.number ? `#${inv.number}` : ''} | ${formatEuros(inv.total)}`
            return label === invoiceLabel
        })

        if (selectedInvoice) {
            setAssociatedDocumentId(selectedInvoice.id)
            onAssociatedDocumentChange && onAssociatedDocumentChange(selectedInvoice.id)

            onChange && onChange({
                ...value,
                items: selectedInvoice.items || [],
            })
        }
    }


    // Fetch available invoices when client changes and type is Credit Note
    useEffect(() => {
        if (value.type === InvoiceDocumentType.CreditNote && value.clientId && !readOnly) {
            setLoadingInvoices(true)
            getInvoicesAsync(value.clientId, value.branchId)
                .then((invoices) => {
                    // Filter out credit notes and receipts, only show regular invoices
                    const filtered = invoices.filter(inv =>
                        inv.type !== InvoiceDocumentType.CreditNote &&
                        inv.type !== InvoiceDocumentType.Receipt &&
                        inv.state === InvoiceState.Issued
                    )
                    // Fetch full details for all invoices to have complete data
                    return Promise.all(filtered.map(inv => getInvoiceAsync(inv.id)))
                })
                .then((fullInvoices) => {
                    setAvailableInvoices(fullInvoices)
                })
                .catch((error) => {
                    console.error('Error fetching client invoices:', error)
                    setAvailableInvoices([])
                    const message = getErrorMessage(error)
                    dispatch(alertError(message ?? t(TK.somethingWentWrong)))
                })
                .finally(() => {
                    setLoadingInvoices(false)
                })
        } else {
            setAvailableInvoices([])
            setAssociatedDocumentId('')
        }
    }, [value.branchId, value.clientId, value.type, readOnly])

    const getItemTotal = (item: InvoiceItem) => {
        const baseTotal = item.unitPrice * item.quantity * (100 - (item.discountPercentage ?? 0)) / 100
        if (readOnly) return baseTotal
        const taxRate = taxHook.taxRates.find(t => t.id === item.taxId)?.rate ?? 0
        return baseTotal * (1 + (taxRate / 100))
    }
    const totalWithVAT = items.reduce((sum, curr) => sum + getItemTotal(curr), 0)

    // Calculate discount (applied after VAT)
    const discountAmount = readOnly
        ? (value.globalDiscountAmount ?? 0)
        : (value.globalDiscountAmount ?? (value.globalDiscountPercentage ? (totalWithVAT * value.globalDiscountPercentage / 100) : 0))
    const totalWithVATAfterDiscount = totalWithVAT - discountAmount
    const totalForDisplay = readOnly && isExistingInvoice
        ? (value as Invoice).total
        : totalWithVATAfterDiscount

    const hasCreditNote = isExistingInvoice && (value as Invoice).relatedDocuments?.some(doc => doc.type === InvoiceDocumentType.CreditNote)
    const isCreditNote = value.type === InvoiceDocumentType.CreditNote

    const hasReceipt = isExistingInvoice && (value as Invoice).relatedDocuments?.some(doc => doc.type === InvoiceDocumentType.Receipt)
    const receiptDoc = isExistingInvoice ? (value as Invoice).relatedDocuments?.find(doc => doc.type === InvoiceDocumentType.Receipt) : undefined
    const isReceipt = value.type === InvoiceDocumentType.Receipt

    const showCancelButton = onCancel
        && invoiceState !== InvoiceState.Draft
        && invoiceState !== InvoiceState.Canceled
        && !hasCreditNote
        && !isCreditNote
        && !isReceipt
        && !userPermissions.includes(PermissionEnum.DoNotAllowToCancelInvoices)

    const showEmitReceiptButton = onEmitReceipt
        && invoiceState !== InvoiceState.Draft
        && invoiceState !== InvoiceState.Canceled
        && !hasCreditNote
        && !isCreditNote
        && !isReceipt
        && value.type === InvoiceDocumentType.Invoice
        && !hasReceipt
        && !userPermissions.includes(PermissionEnum.DoNotAllowToEmitInvoices)

    const hasEmptyItemCodes = (value.items ?? []).some(item => !(item.code?.trim()))
    const emitDisabled = fetching
        || (isCreditNote && !associatedDocumentId)
        || hasEmptyItemCodes
        || ((value.items?.length ?? 0) === 0)

    const showSeeReceiptButton = onNavigateToRelatedDoc
        && hasReceipt
        && receiptDoc
    const showStandaloneInvoiceWarning = !readOnly
        && !!onSubmit
        && !value.appointmentId
        && !value.packId
        && selectedAppointmentIds.length === 0

    return (
        <div style={{display: 'flex', flexDirection: 'column', margin: 'var(--spacer-M)', marginTop: 'var(--spacer-L)'}}>
            {showStandaloneInvoiceWarning && (
                <Alert color="warning">{t(TK.standaloneInvoicePaymentsWarning)}</Alert>
            )}

            <div style={{display: 'flex', alignItems: 'flex-start', gap: 'var(--spacer-S)'}}>
                {useBranches && !isFinalConsumer && (
                    <div style={{flex: 1}}>
                        {canEditBranch ? (
                            <AutocompleteTextField
                                id="invoice-branch-select"
                                disabled={branchOptionLabels.length === 0}
                                options={branchOptionLabels}
                                value={normalizedBranchSelectLabel}
                                variant='nobox'
                                inputStyle={{fontWeight: 'bold'}}
                                onValueChanged={(label) => {
                                    const branchId = resolveInvoiceBranchFilterId(label, settings.general?.branches);
                                    if (!branchId) {
                                        return;
                                    }

                                    onChange && onChange({ ...value, branchId });
                                }}
                            />
                        ) : (
                            <TextInputField
                                readOnly
                                variant='standard'
                                inputStyle={{fontWeight: 'bold'}}
                                value={branchLabel}
                            />
                        )}
                    </div>
                )}
                <div style={{display: 'flex', flexDirection: 'column', alignSelf: 'flex-end', flexGrow: 1, maxWidth: '30rem', marginLeft: 'auto'}}>
                    <div style={{display: 'flex', alignItems: 'flex-start', gap: 'var(--spacer-XS)'}}>
                        <div style={{flexGrow: 1}}>
                            <AutocompleteTextField
                                value={isFinalConsumer ? FINAL_CONSUMER_OPTION : clientSearchConfig.getOptionByClientId(value.clientId) ?? value?.clientName}
                                placeholder={t(TK.client)}
                                options={clientSearchConfig.options}
                                optionLabelResolver={clientSearchConfig.optionLabelResolver}
                                searchTextResolver={clientSearchConfig.searchTextResolver}
                                searchMatcher={clientSearchConfig.searchMatcher}
                                readOnly={readOnly}
                                variant='nobox'
                                inputStyle={{fontWeight: 'bold'}}
                                onValueChanged={handleClientSelected}
                                onTextChanged={handleClientTextChanged}
                                anchoredItem={FINAL_CONSUMER_OPTION}
                                renderItemIcon={(option) =>
                                    option === FINAL_CONSUMER_OPTION
                                        ? <PersonIcon style={{ fontSize: '1.2rem' }} />
                                        : null
                                }
                            />
                        </div>
                        {hasClientDataChanged && !readOnly && (
                            <>
                                <InfoIcon
                                    id="client-change-warning-icon"
                                    style={{
                                        color: 'var(--warning-color)',
                                        fontSize: '1.2rem',
                                        cursor: 'pointer',
                                        marginTop: 'var(--spacer-XXS)'
                                    }}
                                />
                                <ToolTip
                                    target="client-change-warning-icon"
                                    toolTipContent={t(TK.invoiceClientChangeWarning)}
                                />
                            </>
                        )}
                    </div>
                    {!isFinalConsumer && (
                        <>
                            <TextInputField
                                value={value?.address}
                                placeholder={t(TK.address)}
                                readOnly={readOnly}
                                variant='nobox'
                                inputStyle={{fontSize: '0.8rem'}}
                                onChange={address => onChange && onChange({...value, clientId: undefined, address})}
                            />
                            <TextInputField
                                value={value?.city}
                                placeholder={t(TK.city)}
                                readOnly={readOnly}
                                variant='nobox'
                                inputStyle={{fontSize: '0.8rem'}}
                                onChange={city => onChange && onChange({...value, clientId: undefined, city})}
                            />
                            <TextInputField
                                value={value?.country}
                                placeholder={t(TK.country)}
                                readOnly={readOnly}
                                variant='nobox'
                                inputStyle={{fontSize: '0.8rem'}}
                                onChange={country => onChange && onChange({...value, clientId: undefined, country})}
                            />
                            {canSelectAppointments && (
                                <AppButton
                                    color="link"
                                    size="sm"
                                    onClick={handleOpenAppointmentsModal}
                                    disabled={appointmentsLoading}
                                    style={{ padding: 0, alignSelf: 'flex-start' }}
                                >
                                    {appointmentsLoading ? t(TK.loading) : `+ ${t(TK.addAppointments)}`}
                                </AppButton>
                            )}
                        </>
                    )}
                </div>
            </div>
            <div style={{marginBottom: 'var(--spacer-M)', marginTop: 'var(--spacer-M)'}}>
                <AutocompleteTextField
                    value={typeLabel}
                    label={t(TK.documentType)}
                    options={
                        allowCreditNote
                            ? [
                                t(TK.invoice),
                                t(TK.invoiceReceipt),
                                t(TK.simplifiedInvoice),
                                t(TK.creditNote),
                            ]
                            : [
                                t(TK.invoice),
                                t(TK.invoiceReceipt),
                                t(TK.simplifiedInvoice),
                            ]
                    }
                    inputStyle={{fontSize: '1.6rem'}}
                    readOnly={readOnly}
                    variant='standard'
                    onValueChanged={val => onChange && onChange({
                        ...value,
                        type: val === t(TK.invoice) ? InvoiceDocumentType.Invoice
                            : val === t(TK.invoiceReceipt) ? InvoiceDocumentType.InvoiceReceipt
                            : val === t(TK.simplifiedInvoice) ? InvoiceDocumentType.SimplifiedInvoice
                            : val === t(TK.creditNote) ? InvoiceDocumentType.CreditNote
                            : InvoiceDocumentType.SimplifiedInvoice
                    })}
                />
                <div style={{display: 'flex', gap: 'var(--spacer-S)', marginTop: 'var(--spacer-S)'}}>
                    <TextInputField
                        label={t(TK.date)}
                        readOnly
                        variant='nobox'
                        value={value.date?.substring(0, 10) ?? moment().format('yyyy-MM-DD')}
                    />
                    {'number' in value &&
                        <TextInputField
                            label={t(TK.number)}
                            readOnly
                            variant='nobox'
                            value={value.number}
                        />
                    }
                    {!isFinalConsumer && (
                        <TextInputField
                            label={t(TK.taxNumber)}
                            readOnly={readOnly}
                            variant='nobox'
                            placeholder='000000000'
                            maxLength={9}
                            value={value.clientTaxNumber}
                            onChange={handleTaxNumberChange}
                        />
                    )}
                </div>
                {allowCreditNote && isCreditNote && !readOnly && (
                    <div style={{marginTop: 'var(--spacer-M)'}}>
                        <AutocompleteTextField
                            value={(() => {
                                if (!associatedDocumentId) return ''
                                const selected = availableInvoices.find(inv => inv.id === associatedDocumentId)
                                if (!selected) return ''
                                return `${getInvoiceTypeText(selected.type, t)} ${selected.number ? `#${selected.number}` : ''} | ${formatEuros(selected.total)}`
                            })()}
                            label={<span>{t(TK.associatedDocuments)} <b style={{color: 'red'}}>*</b></span>}
                            placeholder={loadingInvoices ? t(TK.loading) : value.clientId ? t(TK.select) : t(TK.selectClientFirst)}
                            options={availableInvoices.map(inv => `${getInvoiceTypeText(inv.type, t)} ${inv.number ? `#${inv.number}` : ''} | ${formatEuros(inv.total)}`)}
                            readOnly={loadingInvoices || !value.clientId}
                            variant='nobox'
                            onValueChanged={handleAssociatedDocumentSelected}
                        />
                    </div>
                )}
            </div>
            <div>
                <hr/>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: "100%", minWidth: '22rem' }}>
                                    {t(TK.code)}/{t(TK.description)} {!readOnly && <IconButton onClick={handleAddItem} size="small"><AddCircleIcon/></IconButton>}
                                </TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '8rem' }}>{t(TK.unitPrice)}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '8rem' }}>{t(TK.quantity)}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '7rem' }}>{t(TK.vat)}</TableCell>
                                {/* <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '7rem' }}>{t(TK.discount)}</TableCell> */}
                                <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '8rem' }}>{t(TK.total)}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map((item, idx) => (
                                <TableRow key={idx}>
                                    <TableCell sx={{ width: "100%" }}>
                                        <div style={{display: 'flex'}}>
                                            {!readOnly && 
                                                <AppButton
                                                    style={{position: 'relative', left: '-10px'}}
                                                    color="link"
                                                    size="sm"
                                                    onClick={handleDeleteItem(idx)}
                                                >
                                                    <DeleteIcon fontSize="small" color="error" />
                                                </AppButton>
                                            }
                                            {item.taxExemption && <span style={{color: 'grey', fontSize: '0.6rem', marginRight: 'var(--spacer-XXS)'}}>(*)</span>}
                                            <div style={{flexGrow: 1}}>
                                                <AutocompleteTextField
                                                    value={item.code}
                                                    placeholder={t(TK.code)}
                                                    readOnly={readOnly}
                                                    variant='nobox'
                                                    options={invoiceItems?.defaultItems?.map(i => i.code) ?? []}
                                                    onValueChanged={handleDefaultItemSelected(idx)}
                                                    onTextChanged={code => handleItemChanged(idx, {...item, code})}
                                                    onAddNewOption={code => handleItemChanged(idx, {...item, code})}
                                                    commitOnBlur
                                                />
                                                <TextInputField 
                                                    value={item.description}
                                                    placeholder={t(TK.description)}
                                                    readOnly={readOnly}
                                                    variant='nobox'
                                                    type='textarea'
                                                    rows={item.description?.split('\n').length ?? 1}
                                                    inputStyle={{fontSize: '0.8rem', height: '1rem'}}
                                                    onChange={description => handleItemChanged(idx, {...item, description})}
                                                />
                                            </div>
                                        </div>
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '8rem' }}>
                                        <NumberInputField 
                                            value={item.unitPrice}
                                            readOnly={readOnly}
                                            variant='nobox'
                                            prepend='€'
                                            min={0}
                                            onChange={unitPrice => handleItemChanged(idx, {...item, unitPrice: unitPrice ?? 0})}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '8rem' }}>
                                        <NumberInputField 
                                            value={item.quantity}
                                            readOnly={readOnly}
                                            variant='nobox'
                                            min={0}
                                            onChange={quantity => handleItemChanged(idx, {...item, quantity: quantity ?? 1})}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '6rem' }} onClick={() => setItemTaxModal(idx)}>
                                        <NumberInputField
                                            inputStyle={{cursor: 'pointer'}} 
                                            readOnly={readOnly}
                                            onClick={() => setItemTaxModal(idx)}
                                            value={taxHook.taxRates.find(t => t.id === item.taxId)?.rate ?? 0}
                                            variant='nobox'
                                            prepend='%'
                                        />
                                    </TableCell>
                                    {/* <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '7rem' }}>
                                        <NumberInputField 
                                            value={item.discountPercentage}
                                            variant='nobox'
                                            append='%'
                                            min={0}
                                            max={100}
                                            onChange={discountPercentage => handleItemChanged(idx, {...item, discountPercentage})}
                                        />
                                    </TableCell> */}
                                    <TableCell sx={{ whiteSpace: 'nowrap', minWidth: '8rem' }}>
                                        <NumberInputField 
                                            value={Math.floor(getItemTotal(item) * 100) / 100}
                                            variant='nobox'
                                            prepend='€'
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            {items.filter(i => i.taxExemption).length > 0 && <div style={{marginTop: 'var(--spacer-XS)'}}>
                {items.filter(i => i.taxExemption).map(i => <div style={{display: 'flex', gap: 'var(--spacer-XS)', color: 'grey', fontSize: '0.6rem'}}>
                    (*)
                    <span>{taxHook.getTaxExemptionNameFromTaxExemptionId(i.taxExemption)}</span>
                    -
                    <span>{i.taxExemptionLaw}</span>
                </div>)}
            </div>}
            <div>
                <hr/>
                <div className='to-flex-column-on-sm' style={{display: 'flex', gap: 'var(--spacer-M)'}}>
                    <div style={{flex: 1}}>
                        <TextInputField
                            value={value?.observations}
                            label={t(TK.observations)}
                            type='textarea'
                            readOnly={readOnly}
                            variant='nobox'
                            inputStyle={{fontSize: '0.8rem'}}
                            onChange={observations => onChange && onChange({...value, observations})}
                        />
                    </div>
                    {isExistingInvoice && (value as Invoice).relatedDocuments?.length > 0 && (
                        <div style={{flex: 1, position: 'relative'}}>
                            <label style={{
                                fontSize: '0.75rem',
                                color: 'rgba(0, 0, 0, 0.6)',
                                fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                                fontWeight: 400,
                                lineHeight: 1.4375,
                                letterSpacing: '0.00938em',
                                display: 'block',
                                marginBottom: 'var(--spacer-XXS)'
                            }}>
                                {t(TK.associatedDocuments)}
                            </label>
                            <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-XXS)'}}>
                                {(value as Invoice).relatedDocuments.map((relatedDoc, idx) => (
                                    <div
                                        key={idx}
                                        onClick={handleRelatedDocClick(relatedDoc)}
                                        style={{
                                            fontSize: '0.8rem',
                                            color: '#666',
                                            cursor: 'pointer',
                                            textDecoration: 'underline',
                                            transition: 'color 0.2s',
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.color = '#333'}
                                        onMouseLeave={(e) => e.currentTarget.style.color = '#666'}
                                    >
                                        {getInvoiceTypeText(relatedDoc.type, t)} | {relatedDoc.number}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div>
                <hr/>

                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 'var(--spacer-S)'}}>
                    {(value.type === InvoiceDocumentType.InvoiceReceipt || value.type === InvoiceDocumentType.Receipt) && !readOnly && (() => {
                        const completedPayments = (value.payments ?? []).filter(p => p.status === PaymentStatus.Manual || p.status === PaymentStatus.Success)
                        if (completedPayments.length === 0 && paymentMethodOptions && paymentMethodOptions.length > 0) {
                            return (
                                <div style={{minWidth: '14rem'}}>
                                    <AutocompleteTextField
                                        value={paymentMethod ?? ''}
                                        label={t(TK.paymentType)}
                                        placeholder={t(TK.selectPaymentMethod)}
                                        options={paymentMethodOptions}
                                        variant='nobox'
                                        onValueChanged={method => onPaymentMethodChange && onPaymentMethodChange(method)}
                                    />
                                </div>
                            )
                        }
                        return null
                    })()}
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginLeft: 'auto'}}>
                        {discountAmount > 0 && (
                            <div style={{marginBottom: 'var(--spacer-XS)', display: 'flex', alignItems: 'center', gap: 'var(--spacer-XS)'}}>
                                {!readOnly && (
                                    <>
                                        <IconButton id="edit-discount-button" size='small' onClick={() => setDiscountModalOpen(true)}>
                                            <PercentIcon/>
                                        </IconButton>
                                        <ToolTip target='edit-discount-button' toolTipContent={`${t(TK.edit)} ${t(TK.discount).toLowerCase()}`}/>
                                    </>
                                )}
                                <span style={{color: 'var(--text-muted)', fontSize: '0.9rem'}}>
                                    {t(TK.discount)}: {formatEuros(discountAmount)}
                                    {value.globalDiscountPercentage && ` (${value.globalDiscountPercentage}%)`}
                                </span>
                            </div>
                        )}
                        <h4><b>{t(TK.total)}:</b> {formatEuros(totalForDisplay)}</h4>
                    </div>
                </div>
                {(value.type === InvoiceDocumentType.InvoiceReceipt || value.type === InvoiceDocumentType.Receipt) && (() => {
                    const completedPayments = (value.payments ?? []).filter(p => p.status === PaymentStatus.Manual || p.status === PaymentStatus.Success)
                    if (completedPayments.length > 0) {
                        return (
                            <div style={{marginTop: 'var(--spacer-S)', display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 'var(--spacer-XXS)'}}>
                                {completedPayments.map((p, idx) => (
                                    <span key={idx} style={{fontSize: '0.85rem', color: 'var(--text-muted)'}}>
                                        <PaymentLabel style={{display: 'inline'}} paymentType={p.type} /> - {formatEuros(p.value)}
                                    </span>
                                ))}
                            </div>
                        )
                    }
                    return null
                })()}
            </div>
            <div>
                <hr/>
                <div style={{display: 'flex', justifyContent: 'space-between', gap: 'var(--spacer-S)'}}>
                    <div style={{display: 'flex', gap: 'var(--spacer-XS)'}}>
                        {onFinalize && invoiceState === InvoiceState.Draft && (
                            <>
                                <IconButton id="finalize-invoice-button" size='small' disabled={fetching} onClick={onFinalize} color="success">
                                    <CheckIcon/>
                                </IconButton>
                                <ToolTip target='finalize-invoice-button' toolTipContent={t(TK.finalize)}/>
                            </>
                        )}
                        {onDelete && invoiceState === InvoiceState.Draft && (
                            <>
                                <IconButton id="delete-invoice-button" size='small' disabled={fetching} onClick={onDelete} color="error">
                                    <DeleteIcon/>
                                </IconButton>
                                <ToolTip target='delete-invoice-button' toolTipContent={t(TK.deleteDraft)}/>
                            </>
                        )}
                    </div>
                    <div style={{display: 'flex', gap: 'var(--spacer-XS)', alignItems: 'center'}}>
                        {readOnly ? (
                            <>
                                {showNavigationButtons && value.appointmentId && onOpenAppointment && (
                                    <>
                                        <IconButton id="open-appointment-button" size='small' disabled={fetching} onClick={onOpenAppointment}>
                                            <EventIcon/>
                                        </IconButton>
                                        <ToolTip target='open-appointment-button' toolTipContent={t(TK.openAppointment)}/>
                                    </>
                                )}
                                {showNavigationButtons && value.packId && onOpenPack && (
                                    <>
                                        <IconButton id="open-pack-button" size='small' disabled={fetching} onClick={onOpenPack}>
                                            <LocalOfferIcon/>
                                        </IconButton>
                                        <ToolTip target='open-pack-button' toolTipContent={t(TK.openPack)}/>
                                    </>
                                )}
                                {isExistingInvoice && (
                                    <>
                                        <IconButton id="assign-invoice-button" size='small' disabled={fetching} onClick={() => setAssignModalOpen(true)}>
                                            <LinkIcon/>
                                        </IconButton>
                                        <ToolTip target='assign-invoice-button' toolTipContent={t(TK.assignInvoice)}/>
                                    </>
                                )}
                                {onFinalize && invoiceState === InvoiceState.Draft && (
                                    <>
                                        <IconButton id="finalize-invoice-button" size='small' disabled={fetching} onClick={onFinalize} color="success">
                                            <CheckIcon/>
                                        </IconButton>
                                        <ToolTip target='finalize-invoice-button' toolTipContent={t(TK.finalize)}/>
                                    </>
                                )}
                                {showCancelButton && (
                                    <>
                                        <IconButton
                                            id="cancel-invoice-button"
                                            size='small'
                                            disabled={fetching}
                                            onClick={onCancel}
                                            style={{ color: '#dc3545' }}
                                        >
                                            <DeleteIcon/>
                                        </IconButton>
                                        <ToolTip target='cancel-invoice-button' toolTipContent={t(TK.cancelInvoice)}/>
                                    </>
                                )}
                                {onDelete && invoiceState === InvoiceState.Draft && (
                                    <>
                                        <IconButton id="delete-invoice-button" size='small' disabled={fetching} onClick={onDelete} style={{ color: '#dc3545' }}>
                                            <DeleteIcon/>
                                        </IconButton>
                                        <ToolTip target='delete-invoice-button' toolTipContent={t(TK.deleteDraft)}/>
                                    </>
                                )}
                                {onSendByEmail && (
                                    <>
                                        <span id="send-email-button" style={{display: 'inline-flex'}}>
                                            <IconButton
                                                size='small'
                                                disabled={fetching || sendEmailDisabled}
                                                onClick={onSendByEmail}
                                                style={{ color: sentByEmail ? 'green' : undefined }}
                                            >
                                                <MailIcon/>
                                            </IconButton>
                                        </span>
                                        <ToolTip target='send-email-button' toolTipContent={sendEmailTooltip}/>
                                    </>
                                )}
                                {onGeneratePdf && (
                                    <>
                                        <IconButton id="generate-pdf-button" size='small' disabled={fetching} onClick={onGeneratePdf}><DownloadIcon/></IconButton>
                                        <ToolTip target='generate-pdf-button' toolTipContent={t(TK.generateInvoicePdfFile)}/>
                                    </>
                                )}
                                {showEmitReceiptButton && <AppButton onClick={onEmitReceipt} color='success'>{t(TK.emitReceipt)}</AppButton>}
                                {showSeeReceiptButton && <AppButton onClick={() => receiptDoc && onNavigateToRelatedDoc && onNavigateToRelatedDoc(receiptDoc.id.toString())} outline>{t(TK.seeReceipt)}</AppButton>}
                                {onClose && <AppButton onClick={onClose}>{t(TK.close)}</AppButton>}
                            </>
                        ) : (
                            <>
                                {showNavigationButtons && value.appointmentId && onOpenAppointment && (
                                    <>
                                        <IconButton id="open-appointment-button" size='small' disabled={fetching} onClick={onOpenAppointment}>
                                            <EventIcon/>
                                        </IconButton>
                                        <ToolTip target='open-appointment-button' toolTipContent={t(TK.openAppointment)}/>
                                    </>
                                )}
                                {showNavigationButtons && value.packId && onOpenPack && (
                                    <>
                                        <IconButton id="open-pack-button" size='small' disabled={fetching} onClick={onOpenPack}>
                                            <LocalOfferIcon/>
                                        </IconButton>
                                        <ToolTip target='open-pack-button' toolTipContent={t(TK.openPack)}/>
                                    </>
                                )}
                                {onSubmit && (
                                    <>
                                        <label
                                            id="toggle-send-email-button"
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 'var(--spacer-XXS)',
                                                marginBottom: 0,
                                                cursor: sendEmailDisabled ? 'not-allowed' : 'pointer',
                                                opacity: sendEmailDisabled ? 0.7 : 1,
                                            }}
                                        >
                                        <CheckInputField
                                            value={!!value.sendEmail}
                                            disabled={sendEmailDisabled}
                                            onChange={() => onChange && onChange({ ...value, sendEmail: !value.sendEmail })}
                                        />
                                            <Typography size='small' style={{ whiteSpace: 'nowrap' }}>
                                                {t(TK.sendInvoiceByEmailToClient)}
                                            </Typography>
                                        </label>
                                        <ToolTip
                                            target='toggle-send-email-button'
                                            toolTipContent={sendEmailDisabled ? t(TK.clientEmailRequiredToSendInvoice) : t(TK.sendInvoiceByEmailToClient)}
                                        />
                                    </>
                                )}
                                {onSendByEmail && (
                                    <>
                                        <span id="send-email-button" style={{display: 'inline-flex'}}>
                                            <IconButton
                                                size='small'
                                                disabled={fetching || sendEmailDisabled}
                                                onClick={onSendByEmail}
                                                style={{ color: sentByEmail ? 'green' : undefined }}
                                            >
                                                <MailIcon/>
                                            </IconButton>
                                        </span>
                                        <ToolTip target='send-email-button' toolTipContent={sendEmailTooltip}/>
                                    </>
                                )}
                                {onGeneratePdf && (
                                    <>
                                        <IconButton id="generate-pdf-button" size='small' disabled={fetching} onClick={onGeneratePdf}><DownloadIcon/></IconButton>
                                        <ToolTip target='generate-pdf-button' toolTipContent={t(TK.generateInvoicePdfFile)}/>
                                    </>
                                )}
                                {!readOnly && (
                                    <>
                                        <IconButton id="add-discount-button" size='small' onClick={() => setDiscountModalOpen(true)}>
                                            <PercentIcon/>
                                        </IconButton>
                                        <ToolTip target='add-discount-button' toolTipContent={`${t(TK.add)} ${t(TK.discount).toLowerCase()}`}/>
                                    </>
                                )}
                                {showEmitReceiptButton && <AppButton onClick={onEmitReceipt} outline color='primary'>{t(TK.emitReceipt)}</AppButton>}
                                {showSeeReceiptButton && <AppButton onClick={() => receiptDoc && onNavigateToRelatedDoc && onNavigateToRelatedDoc(receiptDoc.id.toString())} outline>{t(TK.seeReceipt)}</AppButton>}
                                {showCancelButton && <AppButton onClick={onCancel} outline color='danger'>{t(TK.cancelInvoice)}</AppButton>}
                                {onClose && <AppButton onClick={onClose}>{t(TK.close)}</AppButton>}
                                {onSubmit && <AppButton color='success' disabled={emitDisabled} onClick={onSubmit}>{t(TK.emit)}</AppButton>}
                            </>
                        )}
                    </div>
                </div>
            </div>

            <Modal isOpen={appointmentsModalOpen} toggle={() => setAppointmentsModalOpen(false)} size="lg">
                <ModalHeader toggle={() => setAppointmentsModalOpen(false)}>
                    {t(TK.selectAppointments)}
                </ModalHeader>
                <ModalBody>
                    {appointmentsLoading && (
                        <div style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                            {t(TK.loading)}
                        </div>
                    )}
                    {!appointmentsLoading && orderedAppointments.length === 0 && (
                        <div style={{ fontSize: '0.9rem', color: 'var(--text-muted)' }}>
                            {t(TK.noAppointmentsFound)}
                        </div>
                    )}
                    {!appointmentsLoading && orderedAppointments.length > 0 && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacer-XS)' }}>
                            {orderedAppointments.map(appointment => {
                                const appointmentBranchLabel = getBranchLabel(appointment.branchId) || t(TK.noBranch)
                                const isDisabled = !canSelectInvoiceAppointmentBranch(
                                    selectedAppointmentsBranchKey,
                                    appointment.branchId
                                )
                                    && !selectedAppointmentIds.includes(appointment.id)

                                return (
                                    <label
                                        key={appointment.id}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 'var(--spacer-S)',
                                            fontSize: '0.9rem',
                                            opacity: isDisabled ? 0.6 : 1,
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            disabled={isDisabled}
                                            checked={selectedAppointmentIds.includes(appointment.id)}
                                            onChange={() => handleAppointmentToggle(appointment.id)}
                                        />
                                        <span>
                                            {moment(appointment.date).format('YYYY-MM-DD')} - {serviceName(appointment.type, generalSettings)}
                                            {appointment.professionalName ? ` - ${appointment.professionalName}` : ''}
                                            {` - ${t(TK.branch)}: ${appointmentBranchLabel}`}
                                        </span>
                                    </label>
                                )
                            })}
                        </div>
                    )}
                </ModalBody>
            </Modal>

            <Modal isOpen={itemTaxModal !== undefined} toggle={() => setItemTaxModal(undefined)}>
                {itemTaxModal !== undefined && <>
                    <ModalHeader toggle={() => setItemTaxModal(undefined)}>
                        {itemTaxModal+1}. {selectedItem?.code}
                    </ModalHeader>
                    <ModalBody>
                        <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-M)'}}>
                            <AutocompleteTextField
                                value={taxHook.getTaxNameFromTaxId(selectedItem?.taxId)}
                                label={t(TK.tax)}
                                readOnly={readOnly}
                                options={taxHook.taxRates.map(r => r.title)}
                                onValueChanged={taxText => {
                                    if (!selectedItem) return
                                    handleItemChanged(itemTaxModal, {
                                        ...selectedItem,
                                        taxId: taxHook.getTaxIdFromDisplayName(taxText),
                                        typeId: InvoiceItemType.P,
                                        taxExemption: undefined,
                                        taxExemptionLaw: undefined,
                                    })
                                    if (!taxText.includes('0%')) setItemTaxModal(undefined)
                                }}
                            />
                            { selectedItem && taxHook.taxRates.find(t => t.id === selectedItem.taxId)?.rate === 0 && <>
                                <AutocompleteTextField
                                    value={taxHook.getTaxExemptionNameFromTaxExemptionId(selectedItem?.taxExemption)}
                                    label={t(TK.taxExemption)}
                                    readOnly={readOnly}
                                    options={taxHook.taxExemptionOptions}
                                    onValueChanged={taxExemptionText => selectedItem && handleItemChanged(itemTaxModal, {
                                        ...selectedItem,
                                        taxExemption: taxHook.getTaxExemptionIdFromDisplayName(taxExemptionText),
                                    })}
                                />
                                <AutocompleteTextField
                                    value={selectedItem?.taxExemptionLaw}
                                    label={t(TK.taxExemptionLaw)}
                                    readOnly={readOnly}
                                    options={taxHook.taxExemptions.find(t => t.id === selectedItem?.taxExemption)?.law ?? []}
                                    onValueChanged={taxExemptionLaw => selectedItem && handleItemChanged(itemTaxModal, {...selectedItem, taxExemptionLaw})}
                                    onAddNewOption={taxExemptionLaw => selectedItem && handleItemChanged(itemTaxModal, {...selectedItem, taxExemptionLaw})}
                                />
                            </>}
                        </div>
                    </ModalBody>
                </>}
            </Modal>

            {isExistingInvoice && (
                <InvoiceAssignModal
                    invoiceId={(value as Invoice).id}
                    isOpen={assignModalOpen}
                    onClose={() => setAssignModalOpen(false)}
                />
            )}

            <Modal isOpen={discountModalOpen} toggle={() => setDiscountModalOpen(false)}>
                <ModalHeader toggle={() => setDiscountModalOpen(false)}>
                    {t(TK.discount)}
                </ModalHeader>
                <ModalBody>
                    <div style={{display: 'flex', flexDirection: 'column', gap: 'var(--spacer-M)'}}>
                        <NumberInputField
                            value={value.globalDiscountPercentage}
                            label={`${t(TK.discount)} (%)`}
                            append='%'
                            min={0}
                            max={100}
                            onChange={globalDiscountPercentage => {
                                onChange && onChange({
                                    ...value,
                                    globalDiscountPercentage: globalDiscountPercentage ?? undefined,
                                    globalDiscountAmount: undefined,
                                })
                            }}
                        />
                        <div style={{textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.9rem'}}>
                            {t(TK.or)}
                        </div>
                        <NumberInputField
                            value={value.globalDiscountAmount}
                            label={`${t(TK.discount)} (€)`}
                            prepend='€'
                            min={0}
                            max={totalWithVAT}
                            onChange={globalDiscountAmount => {
                                onChange && onChange({
                                    ...value,
                                    globalDiscountAmount: globalDiscountAmount ?? undefined,
                                    globalDiscountPercentage: undefined,
                                })
                            }}
                        />
                        <div style={{display: 'flex', justifyContent: 'space-between', marginTop: 'var(--spacer-S)'}}>
                            <AppButton
                                color='danger'
                                outline
                                onClick={() => {
                                    onChange && onChange({
                                        ...value,
                                        globalDiscountPercentage: undefined,
                                        globalDiscountAmount: undefined,
                                    })
                                    setDiscountModalOpen(false)
                                }}
                            >
                                {t(TK.remove)} {t(TK.discount).toLowerCase()}
                            </AppButton>
                            <AppButton onClick={() => setDiscountModalOpen(false)}>
                                {t(TK.close)}
                            </AppButton>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}
